import leadformCompleteTracking from '../../tracking/leadform_complete_tracking';

export default async function submitForm(url, formDetails = {}, method = 'POST', options = {}) {
  const response = await fetch(
    url,
    {
      method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formDetails.formData),
      ...options
    }
  );

  let jsonResponse;
  try { jsonResponse = await response.json(); }
  catch {
    // We weren't able to parse json out of the response, so assume an empty response body
    jsonResponse = { success: response.ok };
  }

  leadformCompleteTracking(formDetails.formVersion);
  if (response.ok) {
    if (response.status === 204) {
      // We shouldn't expect a response body for this status.
      // See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/204
      return '';
    }

    if (jsonResponse && jsonResponse.error) {
      throw Error(`Success response, but data indicated an error: ${ jsonResponse.error }`);
    }

    return jsonResponse;
  }

  let error = new Error(`HTTP status ${response.status}`);
  error.rootCauses = jsonResponse.error ? [jsonResponse.error] : jsonResponse.errors || [];
  throw error;
}
